export default __webpack_public_path__ + "static/media/bg_login.db940fdd.svg";